export default "__VITE_ASSET__DnolFt0O__"